import React from 'react'
import { styled } from '@mui/material/styles';
import Radio, { RadioProps } from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';


const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 10,
    height: 10,
    boxShadow: '0 0 0 1px #E65100',
    backgroundColor: 'transparent',
    // 'input:disabled ~ &': {
    //     boxShadow: 'none',
    //     background:
    //         theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    // },
}));

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#E65100',
    '&:before': {
        display: 'block',
        width: 10,
        height: 10,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#E65100',
    },
});

function BpRadio(props) {
    return (
        <Radio
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon />}
            icon={<BpIcon />}
            {...props}
        />
    );
}


const CustomRadioOne = (props) => {
    return (
        <>
            <FormControlLabel value={props?.value} control={<BpRadio />} label={props?.label} />
        </>
    )
}

export default CustomRadioOne